import { RootState } from '../root.reducers';
import { RegisteredNode } from './registeredNode.types';

export const getRegisteredNodes = (state: RootState): RegisteredNode[] => state.registeredNode.entities;

export const getSelectedRegisteredNode = (state: RootState): RegisteredNode[] => state.registeredNode.select;

export const getRegisteredNode = (state: RootState): RegisteredNode | null =>
  state.registeredNode.single;
